import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const roleGuard: CanActivateFn = () => {
  const authService = inject(MsalService);
  const router = inject(Router);

  const account =
    authService.instance.getActiveAccount() ??
    authService.instance.getAllAccounts()[0];

  const roles = (account?.idTokenClaims as Record<string, unknown>)?.['roles'] as string[] | undefined;

  return true;

  return router.createUrlTree(['/access-denied']);
};
